
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import RevenueSplitManagement from '@/components/masterlicense/RevenueSplitManagement';
import { useMasterLicenseSettings } from '@/contexts/MasterLicenseSettingsContext';

const RevenueSettingsTab: React.FC = () => {
  // Use the context to manage revenue splits state and functions
  const { 
    licenseSettings,
    handleRevenueSplitAdd,
    handleRevenueSplitUpdate,
    handleRevenueSplitDelete,
    handleSaveRevenueSplits,
    isSavingRevenueSplits
  } = useMasterLicenseSettings();
  
  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle>Revenue Split Settings</CardTitle>
        <CardDescription>
          Configure how revenue is split between Master License and Resellers based on monthly volume.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <RevenueSplitManagement
          revenueSplits={licenseSettings.revenueSplits || []}
          onAddRevenueSplit={handleRevenueSplitAdd}
          onUpdateRevenueSplit={handleRevenueSplitUpdate}
          onDeleteRevenueSplit={handleRevenueSplitDelete}
          onSaveRevenueSplits={handleSaveRevenueSplits}
          isSaving={isSavingRevenueSplits}
        />
      </CardContent>
    </Card>
  );
};

export default RevenueSettingsTab;
